(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "yup"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("yup"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.yup);
    global.eventsSchema = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _yup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.trackEmbeddedSchema = _exports.trackEmbeddedClickSchema = _exports.embeddedSessionSchema = _exports.embeddedDismissSchema = void 0;
  var trackEmbeddedSchema = _exports.trackEmbeddedSchema = (0, _yup.object)().shape({
    metadata: (0, _yup.object)().shape({
      messageId: (0, _yup.string)(),
      campaignId: (0, _yup.number)(),
      isProof: (0, _yup["boolean"])(),
      placementId: (0, _yup.number)()
    }),
    elements: (0, _yup.object)().shape({
      title: (0, _yup.string)(),
      body: (0, _yup.string)(),
      mediaUrl: (0, _yup.string)(),
      buttons: (0, _yup.array)().of((0, _yup.object)().shape({
        id: (0, _yup.string)(),
        title: (0, _yup.string)(),
        action: (0, _yup.object)().shape({
          type: (0, _yup.string)(),
          data: (0, _yup.string)()
        })
      })),
      text: (0, _yup.array)().of((0, _yup.object)().shape({
        id: (0, _yup.string)(),
        text: (0, _yup.string)()
      })),
      defaultAction: (0, _yup.array)().of((0, _yup.object)().shape({
        type: (0, _yup.string)(),
        data: (0, _yup.string)()
      }))
    }),
    payload: (0, _yup.array)().of((0, _yup.mixed)())
  });
  var trackEmbeddedClickSchema = _exports.trackEmbeddedClickSchema = (0, _yup.object)().shape({
    messageId: (0, _yup.string)(),
    buttonIdentifier: (0, _yup.string)(),
    targetUrl: (0, _yup.string)(),
    deviceInfo: (0, _yup.object)().shape({
      appPackageName: (0, _yup.string)()
    })
  });
  var embeddedDismissSchema = _exports.embeddedDismissSchema = (0, _yup.object)().shape({
    messageId: (0, _yup.string)().required(),
    buttonIdentifier: (0, _yup.string)(),
    deviceInfo: (0, _yup.object)().shape({
      deviceId: (0, _yup.string)().required(),
      platform: (0, _yup.string)().required(),
      appPackageName: (0, _yup.string)().required()
    }),
    createdAt: (0, _yup.number)()
  });
  var embeddedSessionSchema = _exports.embeddedSessionSchema = (0, _yup.object)().shape({
    session: (0, _yup.object)().shape({
      id: (0, _yup.string)().required(),
      start: (0, _yup.number)().required(),
      end: (0, _yup.number)().required()
    }).required(),
    impressions: (0, _yup.array)().of((0, _yup.object)().shape({
      messageId: (0, _yup.string)().required(),
      displayCount: (0, _yup.number)().required(),
      displayDuration: (0, _yup.number)().required(),
      placementId: (0, _yup.string)()
    })),
    deviceInfo: (0, _yup.object)().shape({
      deviceId: (0, _yup.string)().required(),
      platform: (0, _yup.string)().required(),
      appPackageName: (0, _yup.string)().required()
    }),
    createdAt: (0, _yup.number)()
  });
});